module.exports = __webpack_public_path__ + "img/1525831716813.45672065.jpg";